export const SET_CHANNELS = 'epg/SET_PURE_CHANNELS';
